export default __webpack_public_path__ + "static/char-v-45-3ef1e4c7ea97c935f2fee3c72a8425c2.png";